const storedData = JSON.parse(localStorage.getItem("services")) || [];

export default storedData